// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__1Fn9t","nav":"layout_nav__22gZr","logo":"layout_logo__2iRX9"};